import React from 'react';
import { Box, Button, Heading, Stack, Text } from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';
import Layout from '../components/layout/Layout';
import Container from '../components/ui/Container';

export default function NotFound() {
  return (
    <Layout
      title="Página no encontrada"
      description="La página que busca no existe o fue movida."
    >
      <Container>
        <Box textAlign="center" py={{ base: 16, md: 24 }}>
          <Text fontSize="6xl" fontWeight={700} color="accent.default" lineHeight={1}>
            404
          </Text>
          <Heading as="h1" size="h2" mt={4} mb={4}>
            No encontramos esta página
          </Heading>
          <Text color="text.secondary" maxW="480px" mx="auto" mb={8}>
            Puede que el enlace haya cambiado. Vuelva al inicio o consulte
            nuestro catálogo de soluciones.
          </Text>
          <Stack direction={{ base: 'column', sm: 'row' }} spacing={3} justify="center">
            <Button as={RouterLink} to="/" variant="primary">
              Ir al inicio
            </Button>
            <Button as={RouterLink} to="/services" variant="secondary">
              Ver soluciones
            </Button>
          </Stack>
        </Box>
      </Container>
    </Layout>
  );
}
